module.exports = __webpack_public_path__ + "img/mobile.1825e3b.svg";